<template>
  <swiper
    :pagination="true"
    :navigation="true"
    :modules="modules"
    :class="['mySwiper','max-w-3xl']"
    :auto-height="true"
  >
    <swiper-slide
      v-for="image in article.images"
      :key="image.id"
    >
      <div class="md:pt-5 container w-full px-0 mb-8">
        <img
          :src="image.url"
          :alt="article.title"
          class="md:shadow-lg md:rounded-2xl w-full"
        >
      </div>
    </swiper-slide>
  </swiper>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";

import "swiper/css/navigation";

// import required modules
import { Pagination,Navigation } from "swiper";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  setup() {
    return {
      modules: [Navigation,Pagination],
    };
  },
};
</script>
<style lang="css">
.swiper-button-next{
right: 20px !important;
}
.swiper-button-prev{
left: 20px !important;
}
.swiper-button-prev,.swiper-button-next {
border: none;
width: 20px !important;
height: 20px !important;
border-radius: 50% !important;
background-color: rgb(0, 0, 0, 00.4) !important ;
text-align: center !important;
}
.swiper-button-next:after,.swiper-button-prev:after {
color: #dadde4 !important;
font-size: 8px !important;
}
.swiper-pagination-bullet-active {
  background-color: #304c71;
}
</style>
